import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import BreadCrumb from "../../components/template/BreadCrumb";
import Header from "../../components/template/Header";
import {
  getPages,
  deletePage,
  getNextPages,
  getPreviousPages,
} from "../../store/actions/pages_action";
import { LIMIT } from "../../domain/constant";
import Pagination from "../../components/common/Pagination";
import Filters from "../../components/common/Filters";
import AddBtn from "../../components/common/AddBtn";
import { SEARCH_TERMS, view_all_table } from "../../shared/enums/pages_enum";
import DataTable from "../../components/common/DataTable";
const AllPages = ({
  getPages,
  deletePage,
  getNextPages,
  getPreviousPages,
  page: { loading, pages },
}) => {
  const [page, setPage] = useState(1);
  const [deleteEntry, setDeleteEntry] = useState(null);
  const [q, setQ] = useState(null);
  const [term, setTerm] = useState(null);
  const [termField, setTermField] = useState(SEARCH_TERMS[0]);
  useEffect(() => {
    async function allQuery() {
      if (deleteEntry) {
        await deletePage(deleteEntry);
      }
      getPages({});
    }
    allQuery();
  }, [deleteEntry]);

  const nextButtonClicked = () => {
    if (pages && pages.length === LIMIT) {
      const lastPage = pages[pages.length - 1];
      getNextPages({ last: lastPage });
      setPage(page + 1);
    }
  };
  const prevBtnClicked = () => {
    if (page > 1) {
      const lastPage = pages[0];
      getPreviousPages({
        first: lastPage,
      });
      setPage(page - 1);
    }
  };
  const filterClicked = () => {
    if (term && term.length > 0) {
      setPage(1);
      setQ(term);
      getPages({ term: term, termField: termField });
    }
  };
  const deletePageClicked = (id) => {
    setDeleteEntry(id);
  };
  const resetFilter = () => {
    setPage(1);
    setQ(null);
    setTerm("");
    getPages({});
  };

  return (
    <div className="pace-done">
      <div>
        <Header />
        <BreadCrumb
          title="Pages"
          mainLinkTitle="Dashboard"
          mainLinkUrl="/dashboard"
          activeLink="Page"
        />

        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12">
              <div
                className="card"
                style={{ boxShadow: "rgb(227 233 243) 0px 4px 22px" }}
              >
                <div className="card-body">
                  <AddBtn item="pages" title="Page" />
                  <hr />

                  <Filters
                    q={q}
                    resetFilter={resetFilter}
                    setTerm={setTerm}
                    term={term}
                    filterClicked={filterClicked}
                    termField={termField}
                    setTermField={setTermField}
                    all_terms={SEARCH_TERMS}
                  />
                  <hr />
                  <div>
                    <DataTable
                      keys={view_all_table}
                      data={pages}
                      field={"pages"}
                      page={page}
                      deleteBtnClicked={deletePageClicked}
                      loading={loading}
                    />
                    <Pagination
                      data={pages}
                      page={page}
                      prevBtnClicked={prevBtnClicked}
                      nextButtonClicked={nextButtonClicked}
                      loading={loading}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({ page: state.page });

const mapDispatchToProps = {
  getPages,
  deletePage,
  getNextPages,
  getPreviousPages,
};

export default connect(mapStateToProps, mapDispatchToProps)(AllPages);
